export default String.raw`
{% if page.PageId == config.DefinedPages.ProductDetails.Id and config.External.Edrone.AppId != '' -%}
    <script>
        if(cookieSettingsValue == undefined || cookieSettingsValue == 'granted' || cookieSettingsValue[0] == 'granted'){

            {% if productdetails -%}
                {% assign product-presentation = productdetails -%}
            {% elseif product-details -%}
                {% assign product-presentation = product-details -%}
            {% endif -%}

            window._edrone = window._edrone || {};
            _edrone.action_type = 'product_view';
            _edrone.product_ids = '{{ product-presentation.Product.Id }}';
            _edrone.product_titles = '{{ product-presentation.Product.Name }}';
            {% capture edroneBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
            {% if product-presentation.Product.ImageId > 0 -%}
                _edrone.product_images = '{{ edroneBase }}img/large/{{ product-presentation.Product.ImageId }}/{% if product-presentation.Product.Images[0].Name != "" -%}{{ product-presentation.Product.Images[0].Name }}{% else %}.jpg{% endif %}';
            {% elsif product-presentation.Product.Image.ExternalUrl != null and product-presentation.Product.Image.ExternalUrl != '' -%}
                _edrone.product_images = '{{ product-presentation.Product.Image.ExternalUrl | Replace: "'", '%27' }}';
            {% endif -%}
            {% if product-presentation.Product.Code != '' -%}
                _edrone.product_skus = '{{ product-presentation.Product.Code }}';
            {% endif -%}
            _edrone.product_urls = '{{ page.CanonicalLink }}';
            _edrone.product_category_ids = '{{ page.GroupId }}';
            _edrone.product_category_names = '{{ page.CurrentSiteNode.Name }}';
        }
    </script>
{% endif %}
`